import { Component, Input, OnInit, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import {
  PortalProduct,
  PortalProductsQuery,
  PortalProductSubscription,
  Cart,
  CartQuery,
  CartService,
  CardToken,
  CardTokenQuery,
  CardTokenService,
  CustomerProductSusbcriptionPaymentStatusType,
} from '@fgb/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'fgb-membership-details',
  templateUrl: './membership-details.component.html',
  styleUrls: ['./membership-details.component.scss'],
})
export class MembershipDetailsComponent implements OnInit, OnChanges, OnDestroy {
  @Input() subscribedProduct?: PortalProductSubscription;
  @Input() availableMembershipProducts: PortalProduct[] = [];
  items$: Observable<Cart[]>;
  currentLcid: string | null = '';
  currencyCode: string;
  noticePeriod: Date;
  currentDate: Date;
  withinRenewal: boolean = false;
  renewalProduct: PortalProduct;
  currentSubscribedProduct: PortalProductSubscription;
  itemSub: Subscription;
  defaultCardToken$: Observable<CardToken>;
  daysLeft: number;
  autoRenewal: boolean = false;

  constructor(
    private cartQuery: CartQuery,
    private portalProductsQuery: PortalProductsQuery,
    private cartService: CartService,
    private cardTokenQuery: CardTokenQuery,
    private cardTokenService: CardTokenService,
    private modalService: NgbModal,
    private router: Router
  ) {
    this.currentLcid = localStorage.getItem('lcid');
  }

  ngOnInit() {
    this.items$ = this.cartQuery.selectAllSubscriptionCartData();
    this.defaultCardToken$ = this.cardTokenQuery.selectDefaultCard();
    this.cardTokenService.fetchDefaultCardToken().toPromise();
    this.updateCurrency();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.subscribedProduct && this.subscribedProduct) {
      this.updateStatus();
    }
  }

  get isActive(): boolean {
    return this.currentSubscribedProduct?.SubscriptionPaymentStatus === CustomerProductSusbcriptionPaymentStatusType.Active;
  }

  toggleAutoRenewal() {
    this.autoRenewal = !this.autoRenewal;
  }

  updateCurrency() {
    this.currencyCode = this.currentLcid == '2057' ? 'GBP' : 'EUR';
  }

  ngOnDestroy() {
    if (this.itemSub) {
      this.itemSub.unsubscribe();
    }
  }

  updateStatus() {
    if (!this.subscribedProduct) {
      return;
    }
    if (this.subscribedProduct.ProductType === 1) {
      this.currentSubscribedProduct = this.subscribedProduct;
      this.noticePeriod = new Date(this.currentSubscribedProduct.NextPaymentDueDate);
      this.noticePeriod.setDate(this.noticePeriod.getDate() - 30);
      this.currentDate = new Date();

      const msPerDay = 1000 * 60 * 60 * 24;
      const dueDate = new Date(this.currentSubscribedProduct.NextPaymentDueDate);
      this.daysLeft = Math.max(0, Math.ceil((dueDate.getTime() - this.currentDate.getTime()) / msPerDay));

      if (this.currentDate > this.noticePeriod) {
        this.withinRenewal = true;
        this.getRenewalProduct();
      }
    }
  }

  // get renewal product
  getRenewalProduct() {
    let renewalPortalProducts: PortalProduct[];
    renewalPortalProducts = this.portalProductsQuery.getAllProductsByProductType(8, undefined);
    for (let product of renewalPortalProducts) {
      // will add condition here to compare attribute ID with current product, once attributes added to response
      this.renewalProduct = product;
    }
  }

  // add renewal product to cart
  addRenewalProductToCart() {
    if (!this.checkBasketForRenewal()) {
      this.cartService.addPortalProductToCart(this.renewalProduct);
    }
  }

  // checks if product type 8 renewal portal product exists within basket
  checkBasketForRenewal(): boolean {
    let itemsInCart: Cart[] = [];
    this.itemSub = this.items$.subscribe((data) => {
      itemsInCart = data;
    });
    for (let product of itemsInCart) {
      if (
        product.productData.ProductType === 8 &&
        (product.productData as PortalProduct).ProductId === this.renewalProduct.ProductId
      ) {
        return true;
      }
    }
    return false;
  }

  // info button of subscribed membership
  openProductDescription(content: any) {
    this.modalService.open(content, { centered: true });
  }

  // upgrade plan button for members without an active paid membership
  openUpgradeModal(content: any) {
    this.modalService.open(content, { centered: true, modalDialogClass: 'upgrade-plan-modal-dialog' });
  }

  // confirm upgrade
  upgradeToProduct(product: PortalProduct, modal: any) {
    this.cartQuery.removeItems(this.cartQuery.getMemberPortalProductCart());
    this.cartService.addPortalProductToCart(product);
    modal.dismiss();
    this.router.navigate(['/subscriptions/checkout']);
  }
}
